import { RouterProvider } from '@tanstack/react-router';
import type { JSX } from 'react';

import { router } from './app/router.js';

export function App(): JSX.Element {
  return <RouterProvider router={router} />;
}
